import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Education } from '../../models/education.model';

@Component({
  selector: 'bwc-education-card',
  templateUrl: './education-card.component.html',
  styleUrls: ['./education-card.component.scss'],
})
export class EducationCardComponent {
  @Input() education: Education;
  @Input() isLiked = false;
  @Output() liked = new EventEmitter<Education>();

  onLike(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.liked.emit(this.education);
  }
}
